// extracted by mini-css-extract-plugin
export var numberInputContainer = "_a7-0";
export var startPickingButton = "_a7-1";